const LOGIN_PATH = '/login';
const LOGIN_SSO_PATH = '/loginsso';
const FORGOT_PASSWORD_PATH = '/forgot-pass';
const RECOVER_PASSWORD_PATH = '/recover-pass';
const ACCOUNT_PATH = '/account';
const ACCOUNT_PATH_ADD = `${ACCOUNT_PATH}/add`;
const ACCOUNT_PATH_EDIT = `${ACCOUNT_PATH}/edit`;
const LOGIN_HISTORY_PATH = '/login-history';
const STATISTIC_HISTORY_PATH = '/statistic-login-history';

const EMAILCONFIG_PATH = '/emailconfig';
const EMAILCONFIG_CREATE_PATH = '/emailconfig/create';
const EMAILCONFIG_EDIT_PATH = '/emailconfig/edit';

const LOG_PATH = '/log';

const REPORT_POST_PATH = '/report-post';
const REPORT_POST_SYNTHETIC_PATH = '/report-post-synthentic';
const REPORT_POST_EXCEL_PATH = '/report-post-excel';
const REPORT_POST_EXCEL_QUANTITY_CREATE_BY =
    '/report-post-excel-quantity-createby';
const REPORT_POST_EXCEL_CREATE_BY = '/report-post-excel-createby';

const REPORT_POST_WEBANALYSIS_PATH = '/report-post-web-analysis';
const REPORT_POST_BY_DATETYPE = '/report-post-by-datetype';
const REPORT_POST_VIEW_DETAIL = '/report-post-view-detail';
const REPORT_POST_PUBLISHTIME_DATATYPE_PATH =
    '/report-post-publish-time-data-type';
const REPORT_ADVERTISING_ANALYSIS_PATH = '/advertising-analysis';
const REPORT_COUNT_VISIT_DETAIL = '/report-count-visit-detail';

const DONVIDENGHI_PATH = '/don-vi-de-nghi';
const DONVIDENGHI_CREATE_PATH = `${DONVIDENGHI_PATH}/them`;
const DONVIDENGHI_EDIT_PATH = `${DONVIDENGHI_PATH}/sua`;

const APIROLEMAPPING_PATH = '/api-role-mapping';
const APIROLEMAPPING_CREATE_PATH = `${APIROLEMAPPING_PATH}/them`;
const APIROLEMAPPING_EDIT_PATH = `${APIROLEMAPPING_PATH}/sua`;

const OPENIDDICTAPPLICATION_PATH = '/ung-dung-dang-ky';
const OPENIDDICTAPPLICATION_CREATE_PATH = `${OPENIDDICTAPPLICATION_PATH}/them`;
const OPENIDDICTAPPLICATION_EDIT_PATH = `${OPENIDDICTAPPLICATION_PATH}/sua`;

const MENUITEM_PATH = '/menu';
const MENUITEM_CREATE_PATH = `${MENUITEM_PATH}/them`;
const MENUITEM_EDIT_PATH = `${MENUITEM_PATH}/sua`;

const BAOCAO_PATH = '/bao-cao';

const ROLE_ACCOUNT_PATH = '/role-account';
const ROLE_ACCOUNT_CREATE_PATH = '/role-account/create';
const ROLE_ACCOUNT_EDIT_PATH = '/role-account/edit';

const KYSO_PATH = '/ky-so';

const SIGNED_HUMAN_PATH = '/nguoi-duoc-ky';
const SIGNED_HUMAN_CREATE_PATH = '/nguoi-duoc-ky/create';
const SIGNED_HUMAN_EDIT_PATH = '/nguoi-duoc-ky/edit';

// Common
const CHUDE_PATH = '/chu-de';
const CHUDE_CREATE_PATH = '/chu-de/create';
const CHUDE_EDIT_PATH = '/chu-de/edit';

const DANHMUCPHANMEM_PATH = '/danh-muc-phan-mem';
const DANHMUCPHANMEM_CREATE_PATH = '/danh-muc-phan-mem/create';
const DANHMUCPHANMEM_EDIT_PATH = '/danh-muc-phan-mem/edit';

const CHUONGTRINHHOC_PATH = '/chuong-trinh-hoc';
const CHUONGTRINHHOC_CREATE_PATH = '/chuong-trinh-hoc/create';
const CHUONGTRINHHOC_EDIT_PATH = '/chuong-trinh-hoc/edit';

const CHUYENKHOA_PATH = '/chuyen-khoa';
const CHUYENKHOA_CREATE_PATH = '/chuyen-khoa/create';
const CHUYENKHOA_EDIT_PATH = '/chuyen-khoa/edit';

const CHUYENNGANH_PATH = '/chuyen-nganh';
const CHUYENNGANH_CREATE_PATH = '/chuyen-nganh/create';
const CHUYENNGANH_EDIT_PATH = '/chuyen-nganh/edit';

const DANHMUCVANBANGCHUNGCHI_PATH = '/danh-muc-van-bang-chung-chi';
const DANHMUCVANBANGCHUNGCHI_CREATE_PATH = '/danh-muc-van-bang-chung-chi/create';
const DANHMUCVANBANGCHUNGCHI_EDIT_PATH = '/danh-muc-van-bang-chung-chi/edit';

// QuyTrinhTuyenSinh
const DANGKYDUTUYEN_PATH = '/dang-ky-du-tuyen';
const DANGKYDUTUYEN_CREATE_PATH = '/dang-ky-du-tuyen/create';
const DANGKYDUTUYEN_EDIT_PATH = '/dang-ky-du-tuyen/edit';

const DOTTUYENSINH_PATH = '/dot-tuyen-sinh';
const DOTTUYENSINH_CREATE_PATH = '/dot-tuyen-sinh/create';
const DOTTUYENSINH_EDIT_PATH = '/dot-tuyen-sinh/edit';

// CapNhatKienThucYKhoa (CME)
const CMECONFIG_PATH = '/cme/config';
const CMEDICTIONARY_PATH = '/cme/dictionary';
const CMEDUYETHOSO_PATH = '/cme/duyet-ho-so';
const CMECA_NHAN_PATH = '/cme/ca-nhan';
const CMECA_NHAN_CREATE_PATH = `${CMECA_NHAN_PATH}/create`;
const CMECA_NHAN_EDIT_PATH = `${CMECA_NHAN_PATH}/edit`;
const CMEDASHBOARD_PATH = '/cme/dashboard';
const CMEEVENT_PATH = '/cme/event';
const PHAMVIHANHNGHE_PATH = '/pham-vi-hanh-nghe';
const PHAMVIHANHNGHE_CREATE_PATH = '/pham-vi-hanh-nghe/create';
const PHAMVIHANHNGHE_EDIT_PATH = '/pham-vi-hanh-nghe/edit';

const GIAYPHEPHANHNGHE_PATH = '/giay-phep-hanh-nghe';
const GIAYPHEPHANHNGHE_CREATE_PATH = '/giay-phep-hanh-nghe/create';
const GIAYPHEPHANHNGHE_EDIT_PATH = '/giay-phep-hanh-nghe/edit';

const VANBANG_PATH = '/van-bang';
const VANBANG_CREATE_PATH = '/van-bang/create';
const VANBANG_EDIT_PATH = '/van-bang/edit';

const CHUNGCHINGOAINGU_PATH = '/chung-chi-ngoai-ngu';
const CHUNGCHINGOAINGU_CREATE_PATH = '/chung-chi-ngoai-ngu/create';
const CHUNGCHINGOAINGU_EDIT_PATH = '/chung-chi-ngoai-ngu/edit';

const THONGKEDUYET_PATH = '/thong-ke-duyet';

const DANHSACHDUYETHOSO_PATH = '/danh-sach-duyet-ho-so';

export const URI_INTERNAL = {
    REPORT_ADVERTISING_ANALYSIS_PATH,
    REPORT_POST_VIEW_DETAIL,
    REPORT_POST_BY_DATETYPE,
    REPORT_POST_EXCEL_CREATE_BY,
    REPORT_POST_EXCEL_QUANTITY_CREATE_BY,
    REPORT_POST_SYNTHETIC_PATH,
    REPORT_POST_PATH,
    RECOVER_PASSWORD_PATH,
    FORGOT_PASSWORD_PATH,
    ACCOUNT_PATH_EDIT,
    ACCOUNT_PATH_ADD,
    LOGIN_PATH,
    LOGIN_SSO_PATH,
    ACCOUNT_PATH,
    LOGIN_HISTORY_PATH,
    EMAILCONFIG_PATH,
    EMAILCONFIG_CREATE_PATH,
    EMAILCONFIG_EDIT_PATH,
    STATISTIC_HISTORY_PATH,
    LOG_PATH,
    REPORT_POST_EXCEL_PATH,
    REPORT_POST_WEBANALYSIS_PATH,
    REPORT_POST_PUBLISHTIME_DATATYPE_PATH,
    REPORT_COUNT_VISIT_DETAIL,

    DONVIDENGHI_PATH,
    DONVIDENGHI_CREATE_PATH,
    DONVIDENGHI_EDIT_PATH,

    APIROLEMAPPING_PATH,
    APIROLEMAPPING_CREATE_PATH,
    APIROLEMAPPING_EDIT_PATH,

    OPENIDDICTAPPLICATION_PATH,
    OPENIDDICTAPPLICATION_CREATE_PATH,
    OPENIDDICTAPPLICATION_EDIT_PATH,

    MENUITEM_PATH,
    MENUITEM_CREATE_PATH,
    MENUITEM_EDIT_PATH,

    ROLE_ACCOUNT_PATH,
    ROLE_ACCOUNT_CREATE_PATH,
    ROLE_ACCOUNT_EDIT_PATH,

    BAOCAO_PATH,

    KYSO_PATH,

    SIGNED_HUMAN_PATH,
    SIGNED_HUMAN_CREATE_PATH,
    SIGNED_HUMAN_EDIT_PATH,

    // Common
    CHUDE_PATH,
    CHUDE_CREATE_PATH,
    CHUDE_EDIT_PATH,

    DANHMUCPHANMEM_PATH,
    DANHMUCPHANMEM_CREATE_PATH,
    DANHMUCPHANMEM_EDIT_PATH,

    CHUONGTRINHHOC_PATH,
    CHUONGTRINHHOC_CREATE_PATH,
    CHUONGTRINHHOC_EDIT_PATH,

    CHUYENKHOA_PATH,
    CHUYENKHOA_CREATE_PATH,
    CHUYENKHOA_EDIT_PATH,

    CHUYENNGANH_PATH,
    CHUYENNGANH_CREATE_PATH,
    CHUYENNGANH_EDIT_PATH,

    DANHMUCVANBANGCHUNGCHI_PATH,
    DANHMUCVANBANGCHUNGCHI_CREATE_PATH,
    DANHMUCVANBANGCHUNGCHI_EDIT_PATH,

    // QuyTrinhTuyenSinh

    DOTTUYENSINH_PATH,
    DOTTUYENSINH_CREATE_PATH,
    DOTTUYENSINH_EDIT_PATH,

    DANGKYDUTUYEN_PATH,
    DANGKYDUTUYEN_CREATE_PATH,
    DANGKYDUTUYEN_EDIT_PATH,

    // CapNhatKienThucYKhoa (CME)
    CMECONFIG_PATH,
    CMEDICTIONARY_PATH,
    CMEDUYETHOSO_PATH,
    CMECA_NHAN_PATH,
    CMECA_NHAN_CREATE_PATH,
    CMECA_NHAN_EDIT_PATH,
    CMEDASHBOARD_PATH,
    CMEEVENT_PATH,
    PHAMVIHANHNGHE_PATH,
    PHAMVIHANHNGHE_CREATE_PATH,
    PHAMVIHANHNGHE_EDIT_PATH,

    GIAYPHEPHANHNGHE_PATH,
    GIAYPHEPHANHNGHE_CREATE_PATH,
    GIAYPHEPHANHNGHE_EDIT_PATH,
    VANBANG_PATH,
    VANBANG_CREATE_PATH,
    VANBANG_EDIT_PATH,
    CHUNGCHINGOAINGU_PATH,
    CHUNGCHINGOAINGU_CREATE_PATH,
    CHUNGCHINGOAINGU_EDIT_PATH,
    DANHSACHDUYETHOSO_PATH,
    THONGKEDUYET_PATH
};
